<template>
  <div class="goodsPayment">
    <Tab title="货款" arrow="hidden" />
    <div class="info">
      <div class="exhibition">
        <div>
          <p>余额</p>
          <p>
            <span>¥</span>
            <span>12345.00</span>
          </p>
        </div>
        <button @click="goWithdrawal()">提现</button>
      </div>
      <div class="detail">
        <p>
          <span>累计货款(元)</span>
          <span>12345.00</span>
        </p>
        <p>
          <span>累计提现(元)</span>
          <span>12345.00</span>
        </p>
        <p>
          <span>提现中(元)</span>
          <span>12345.00</span>
        </p>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="accountDetail">
        <p class="title">账户明细</p>
        <div v-if="list.length!=0" class="practicallist">
          <div class="practical" @click="toDetial()">
            <div>
              <p>货款</p>
              <span>订单号 7893478623587436578</span>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="plus">+123.00</div>
          </div>
          <div class="practical">
            <div>
              <p>提现失败</p>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="plus">+23.00</div>
          </div>
          <div class="practical">
            <div>
              <p>提现</p>
              <span>提现成功</span>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="reduce">-23.00</div>
          </div>
          <div class="practical">
            <div>
              <p>退货款</p>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="reduce">-2000.00</div>
          </div>
          <div class="practical">
            <div>
              <p>提现失败</p>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="plus">+23.00</div>
          </div>
          <div class="practical">
            <div>
              <p>提现</p>
              <span>提现成功</span>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="reduce">-23.00</div>
          </div>
          <div class="practical" v-for="item in list" :key="item">
            <div>
              <p>退货款</p>
              <span>2019-07-07 11:02:00</span>
            </div>
            <div class="reduce">-2000.00</div>
          </div>
        </div>
        <div v-else class="empty">
          <img src="static/img/blank.png" alt />
          <p>您还没有账户明细哦</p>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import Tab from "base/tab/tab";
import Loading from 'base/loading/loading';
export default {
components: {
    Tab,
    Loading
  },
  data() {
    return {
      list: [1,2,3],
      loading: false,
      finished: false,
      isLoading:true 
    };
  },
  methods: {
    goWithdrawal() {
      this.$router.push("/withdrawal");
    },
    // 去详情
    toDetial() {
      this.$router.push("/goods_payment/goods_payment_detail");
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束 
        this.loading = false;    
        // 数据全部加载完成
        if (this.list.length >= 100) {
          this.finished = true;
        }
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
.goodsPayment {
  padding-top: 100px;
  .info {
    margin: 0 30px;
    height: 318px;
    background: url(hk_bg.png) no-repeat;
    background-size: 100% 100%;
    padding: 39px 40px;
    .exhibition {
      display: flex;
      justify-content: space-between;
      margin-bottom: 58px;
      > div {
        p {
          &:nth-child(1) {
            height: 40px;
            font-size: 28px;
            color: rgba(255, 222, 212, 1);
            line-height: 40px;
          }
          &:nth-child(2) {
            span {
              &:nth-child(1) {
                height: 33px;
                font-size: 24px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 33px;
              }
              &:nth-child(2) {
                height: 67px;
                font-size: 48px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                line-height: 67px;
              }
            }
          }
        }
      }
      button {
        margin-top: 15px;
        width: 130px;
        text-align: center;
        height: 56px;
        background: rgba(255, 255, 255, 1);
        border-radius: 28px;
        font-size: 26px;
        font-weight: 500;
        box-sizing: border-box;
        color: rgba(232, 64, 49, 1);
      }
    }
    .detail {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        span {
          &:nth-child(1) {
            height: 33px;
            font-size: 24px;
            color: rgba(255, 222, 212, 1);
            line-height: 33px;
          }
          &:nth-child(2) {
            height: 40px;
            font-size: 28px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
          }
        }
      }
    }
  }
  .accountDetail {
    padding-left: 30px;
    .title {
      height: 92px;
      line-height: 92px;
      font-size: 30px;
      font-weight: 600;
      color: rgba(58, 58, 58, 1);
      border-bottom: 1px solid #d7d7d75c;
    }
    .practicallist {
      .practical {
        padding: 25px 30px 25px 0;
        border-bottom: 1px solid #d7d7d75c;
        display: flex;
        justify-content: space-between;
        > div {
          &:nth-child(1) {
            p {
              height: 45px;
              font-size: 32px;
              color: rgba(58, 58, 58, 1);
              line-height: 45px;
              margin-bottom: 10px;
            }
            span {
              height: 33px;
              font-size: 24px;
              color: rgba(173, 173, 173, 1);
              line-height: 33px;
              display: block;
            }
          }
          &:nth-child(2) {
            height: 53px;
            font-size: 38px;
            color: #5f90fc;
            line-height: 53px;
            &.reduce {
              color: #e84031;
            }
          }
        }
      }
    }
    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      margin-top: 134px;
      img {
        width: 440px;
        margin-bottom: 30px;
      }
      p {
        font-size: 26px;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/goodsPayment/index.vue